import {COMPONENT_ID} from '../symbols';
import {updateSelectedPropertyMappings, getHostVariables} from '../utils';

export default function unstableAddRenderOnPropertySelectorValueChange(host, propertySelector) {
	const hostVariables = getHostVariables(host);
	updateSelectedPropertyMappings(propertySelector, propertySelector, hostVariables[COMPONENT_ID]);
}
